import {
  ModalContent,
  CloseButton,
  Button,
  Modal,
  StatusMessage,
} from "../../style/view.styles";

const ConfirmCancelInternshipModal = ({
  selectedInternship,
  handleWithdraw,
  handleModalClose,
  formStatus,
  submitting,
}) => {
  return (
    <Modal>
      <ModalContent>
        {/* Close Button */}
        <CloseButton onClick={handleModalClose}>X</CloseButton>
        <h2>Confirm Internship Cancellation</h2>
        <p style={{ paddingTop: "10px" }}>
          Are you sure you want to cancel
          <strong> {selectedInternship?.position}</strong> at
          <strong> {selectedInternship?.organization}</strong> internship?
        </p>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            marginTop: "20px",
          }}
        >
          {/* Cancel Button */}
          <Button
            type="button"
            onClick={handleModalClose}
            style={{ backgroundColor: "#ccc" }}
          >
            Ignore
          </Button>
          {/* Confirm Withdrawal Button */}
          <Button
            type="button"
            onClick={() => handleWithdraw(selectedInternship)}
            disabled={submitting}
          >
            Confirm
          </Button>
        </div>
        {formStatus.message && (
          <StatusMessage type={formStatus.type}>
            {formStatus.message}
          </StatusMessage>
        )}
      </ModalContent>
    </Modal>
  );
};

export default ConfirmCancelInternshipModal;
